import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  border-bottom: 1px solid #a6a6a6;
  background-color: #fff;
`;

interface HeaderProps {
  path?: string;
}

export const Header = styled.header<HeaderProps>`
  width: 100%;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #a6a6a6;
  padding: 2rem;
  .menu {
    display: none;
  }
  div {
    display: flex;
    align-items: center;
    h1 {
      margin-left: 0.5rem;
    }
  }
  @media (max-width: 601px) {
    .menu {
      display: flex;
      border: none;
      background-color: transparent;
      font-size: 1.5rem;
    }
    .title {
      margin-left: ${(props) =>
        props.path === 'dashboard' || 'detailing' ? '-1rem' : '-7rem'};
    }
    div {
      h1 {
        font-size: 22px;
      }
    }
  }
  @media (max-width: 416px) {
    .title {
      margin-left: -0.5rem;
    }
    div {
      h1 {
        font-size: ${(props) => (props.path === 'detailing' ? '12px' : '16px')};
      }
    }
  }
`;
export const Monitore = styled.div`
display: flex;
flex-direction: column;
  p {
    strong {
      font-size: 1.2rem;
    }
  }
  div {
    margin-top: 0.2rem;
    width: 100%;
    display: flex;
    justify-content: left;
    cursor: pointer;
    span {
      font-weight: bold;
      margin-right: 1rem;
    }
    div {
      margin-right: 1rem;
      height: 1.5rem;
      width: 1.5rem;
      border-radius: 50%;
      background-color: var(--color-secondary);
    }
  }
  

`;
export const Perfil = styled.div`
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  div {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    h3 {
      font-size: 20px;
      color: #000000;
      text-align: center;
    }
    select {
      border: none;
      outline: none;
      font-weight: 700;
      font-size: 1rem;
      padding: 0 0.5rem;
      option {
        font-weight: 600;
        line-height: 1.5;
        text-align: center;
        background-color: #fff;
        text-transform: capitalize;
      }
    }
  }
  img {
    height: 5rem;
    width: 5rem;
    margin-right: 1rem;
  }
  @media (max-width: 601px) {
    div {
      h3 {
        font-size: 14px;
      }
      select {
        font-size: 14px;
        option {
          font-weight: 600;
          line-height: 1.5;
        }
      }
    }
    img {
      height: 3rem;
      width: 3rem;
      margin-right: 0;
    }
  }
  @media (max-width: 415px) {
    div {
      h3 {
        font-size: 12px;
      }
      select {
        font-size: 12px;
        option {
          font-weight: 600;
          line-height: 1.5;
        }
      }
    }
    img {
      height: 3rem;
      width: 3rem;
      margin-right: 0;
    }
  }
`;
